import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { Interview } from '@app/models/recruiting/interview.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { StoreView } from '@app/modules/common/views';
import { AnalyticService, NotifyService } from '@app/services';
import { cloneDeep } from 'lodash-es';

@Component({
    templateUrl: './job-posting-interviews-store.template.html',
})
export class JobPostingInterviewsStoreView extends StoreView {
    interview: Interview;
    jobPosting: JobPosting;
    isLoading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private notify: NotifyService,
        private analyticService: AnalyticService
    ) {
        super();
        this.jobPosting = this.route.snapshot.data.models.get('jobPosting');

        this.interview = this.route.snapshot.data.models.get('interview')
            ? this.cloneFromExistingInterview()
            : new Interview();
    }

    async onSave(): Promise<void> {
        if (!this.interview.interviewQuestions.length) {
            this.notify.error('applicant-tracker.oneInterviewQuestionRequired');
            return;
        }

        this.isLoading = true;

        try {
            this.interview.atsJobId = this.jobPosting.id;
            const interview: Interview = await this.interview.save();
            await this.saveInterviewQuestions(interview);
            this.notify.success('applicant-tracker.interviewCreated');
            this.analyticService.trackEvent(
                AnalyticEvents.RecruitingJobPostingInterviewsCreateInterviewClickCompleteToSave
            );
            this.router.navigate(['/recruiting', 'jobPostings', this.jobPosting.id, 'interviews']);
        } catch (err) {
            this.notify.error(err || 'applicant-tracker.couldNotSaveInterview');
        }

        this.isLoading = false;
        return;
    }

    private async saveInterviewQuestions(interview: Interview): Promise<void> {
        await interview.interviewQuestions.forEach(async (interviewQuestion: InterviewQuestion) => {
            interviewQuestion.atsInterviewId = interview.id;
            try {
                await interviewQuestion.save();
            } catch (err) {
                this.notify.error(err || 'applicant-tracker.errorSavingInterviewQuestion');
            }
        });
    }

    private cloneFromExistingInterview(): Interview {
        const originalInterview = this.route.snapshot.data.models.get('interview');
        const clonedInterview = cloneDeep(originalInterview);
        clonedInterview.id = null;

        //Reset interview question ids
        clonedInterview.interviewQuestions = clonedInterview.interviewQuestions.map(
            (interviewQuestion: InterviewQuestion) => {
                interviewQuestion.id = null;
                interviewQuestion.atsInterviewId = null;
                return interviewQuestion;
            }
        );

        return clonedInterview;
    }
}
